import React, { memo } from 'react';
import cn from 'classnames';

import Icon from 'components/Icon';
import ButtonV2, { ButtonV2Props } from 'components/form/ButtonV2';

import styles from './SubmitButton.module.scss';

export type SubmitButtonProps = ButtonV2Props & {
  isReady: boolean;
  isDisabled?: boolean;
};

export const SubmitButton: React.FC<SubmitButtonProps> = memo(
  ({ children, className, isReady, isDisabled, ...props }) => {
    const contentClassNames = cn(styles.button, className);

    return (
      <ButtonV2
        size="large"
        type="submit"
        className={contentClassNames}
        disabled={isDisabled}
        {...props}
      >
        {isReady && (
          <Icon
            iconName="tick-mark-circle"
            size="auto"
            className={styles.tickMark}
          />
        )}
        {children}
      </ButtonV2>
    );
  }
);

SubmitButton.displayName = 'SubmitButton';
